import { Box, Heading, VStack, Text } from '@vesyl/ui/chakra'
import { Link } from 'react-router'

/**
 * Dev Tools Index
 * List of all development-only pages and utilities
 */
export default function DevIndexPage() {
  return (
    <Box p="8" maxW="800px" mx="auto">
      <VStack align="stretch" gap="6">
        <Heading>Dev Tools</Heading>
        <Text color="fg.muted">
          Development-only pages and utilities (not available in production)
        </Text>

        <VStack align="stretch" gap="4" mt="4">
          <Link to="/dev/logos" style={{ textDecoration: 'none' }}>
            <Box p="4" borderWidth="1px" borderRadius="md" _hover={{ bg: 'bg.subtle' }}>
              <Heading size="md">Logos</Heading>
              <Text fontSize="sm" color="fg.muted">
                View all logos (VESYL, platforms, carriers) with theme switching
              </Text>
            </Box>
          </Link>

          {/* Add more dev pages here */}
        </VStack>
      </VStack>
    </Box>
  )
}
